
  import { Component, Vue } from 'vue-property-decorator';
  import router from '@/router';

  @Component({})
  export default class PageConfirmEmail extends Vue {
    isLoading: boolean = true;

    created () {
      Promise.resolve()
        .then(() => this.$store.dispatch('auth/init'))
        .then(() => this.$store.dispatch('profile/confirmEmail'))
        .then(() => this.$store.dispatch('initialized'))
        .then(() => this.isLoading = false)
        .catch((error) => {
          let params = {
            textId: 'error.openLater',
            responseData: error.response.data,
            requestData: error.response.config.data,
          };
          return this.$store.dispatch('error', params);
        });
    }

  }
